import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/assetToleranceReport'
import Component from 'components/Reports/AssetToleranceReport'

export default createListViewContainer({ actions, selectors: selectors.assetToleranceReport })(Component)
